import { SxProps } from '@mui/material'
import StylesPrivacyPolicyServiceInterface
  from '~/src/pages/legal/privacy-policy/styles/StylesPrivacyPolicyServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesPrivacyPolicyServiceStyleOne extends TemplateServiceStyleBase implements StylesPrivacyPolicyServiceInterface {
  public getPageSx(): SxProps {
    return {
      display: 'grid',
      py: 3,
      gridTemplateColumns: 'auto 66% auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: '". center ."',
      [this.muiTheme.breakpoints.down('md')]: {
        py: 0,
        gridTemplateAreas: '"center center center"'
      }
    }
  }

  public getCardSx(): SxProps {
    return {
      gridArea: 'center',
      p: 3
    }
  }
}
